module.exports = __webpack_public_path__ + "static/img/banner.c8421c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner.png
// module id = RM3D
// module chunks = 65